import React from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  MenuList,
  SquareButton,
  Tooltip,
  Button,
  SplitButton,
  Icon,
} from 'next/components/ui';
import { fromNow } from 'next/lib/date';
import PublishingManager from './PublishingManager';
import { DropdownListHeading, OptionList } from './styled';

export default function HeaderActions({
  id,
  published,
  updatedAt,
  onClickOpenInBuilder,
}) {
  return (
    <>
      <PublishingManager id={id}>
        {({
          disabled,
          hasChanges,
          onConfirmPublish,
          onConfirmDiscardChanges,
          onConfirmUnpublish,
        }) => (
          <>
            {!published && (
              <Tooltip
                disabled={!disabled}
                label="Contact a team admin or publisher to publish"
              >
                <Button
                  disabled={disabled}
                  kind="primary"
                  onClick={onConfirmPublish}
                  aria-label="Click to Publish"
                >
                  Publish
                </Button>
              </Tooltip>
            )}
            {hasChanges && published && (
              <Tooltip
                disabled={!disabled}
                label="Contact a team admin or publisher to publish"
              >
                <SplitButton kind="positive" disabled={disabled}>
                  <Button
                    aria-label="click to push changes"
                    disabled={disabled}
                    onClick={onConfirmPublish}
                  >
                    Push changes
                  </Button>
                  <Dropdown
                    aria-label="Open change actions"
                    forwardedAs={Button}
                    disabled={disabled}
                    attachment={
                      <>
                        <DropdownListHeading bold>
                          Updated {fromNow(updatedAt)}
                        </DropdownListHeading>
                        <OptionList
                          options={[
                            {
                              label: 'Push changes',
                              onClick: onConfirmPublish,
                            },
                            {
                              label: 'Discard changes',
                              onClick: onConfirmDiscardChanges,
                            },
                            {
                              label: 'Unpublish Pin Experience',
                              onClick: onConfirmUnpublish,
                            },
                          ]}
                        />
                      </>
                    }
                  >
                    <Icon icon="chevron-down" />
                  </Dropdown>
                </SplitButton>
              </Tooltip>
            )}
            {!hasChanges && published && (
              <Button
                disabled={disabled}
                kind="secondary"
                onClick={onConfirmUnpublish}
                aria-label="Click to Unpublish"
              >
                Unpublish
              </Button>
            )}
          </>
        )}
      </PublishingManager>
      <Dropdown
        aria-label="Open pins actions"
        attachment={
          <MenuList
            options={[
              { label: 'Open in Builder', onClick: onClickOpenInBuilder },
            ]}
          />
        }
      >
        <SquareButton kind="secondary" icon="ellipsis-h" />
      </Dropdown>
    </>
  );
}

HeaderActions.propTypes = {
  id: PropTypes.string,
  published: PropTypes.bool,
  updatedAt: PropTypes.number,
  onClickOpenInBuilder: PropTypes.func,
};
